import type { PlacePhoto } from '../types/place'

const webpByFile = import.meta.glob('../../opactwo-cystersow/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>

function urlForFile(file: string): string | null {
  const entry = Object.entries(webpByFile).find(([key]) => key.replace(/\\/g, '/').endsWith(`/${file}`))
  return entry?.[1] ?? null
}

const PHOTOS: { file: string; alt: string }[] = [
  {
    file: 'opactwo-cystersow-lubiaz-z-drona.webp',
    alt: 'Opactwo Cystersów w Lubiążu – widok z lotu ptaka na barokowy zespół klasztorny nad Odrą',
  },
  {
    file: 'opactwo-cystersow-lubiaz-przod.webp',
    alt: 'Opactwo Cystersów w Lubiążu – monumentalna elewacja frontowa jednego z największych opactw w Europie',
  },
  {
    file: 'opactwo-cystersow-lubiaz-4.webp',
    alt: 'Opactwo Cystersów w Lubiążu – barokowa architektura i dziedziniec zespołu klasztornego',
  },
]

function photosFromEntries(entries: { file: string; alt: string }[]): PlacePhoto[] {
  return entries.flatMap((p) => {
    const src = urlForFile(p.file)
    if (!src) return []
    return [{ src, alt: p.alt }]
  })
}

export const opactwoCystersowPhotos: PlacePhoto[] = photosFromEntries(PHOTOS)

/** Obraz wyróżniający artykułu i meta OG (widok z drona). */
export const opactwoCystersowFeaturedPhoto: PlacePhoto | undefined = opactwoCystersowPhotos[0]
